module.exports = __webpack_public_path__ + "static/media/social_security.5e9cf187.png";